import { fg } from '@atlassian/jira-feature-gating';

const AssignAgentsInlineM2TechnicalRelayprovider = {
	get(): boolean {
		return fg('assign-agents-inline_m2_technical');
	},
};

export default AssignAgentsInlineM2TechnicalRelayprovider;
